import React from 'react'
import { Table } from 'react-bootstrap'
const Podetails = ({poChildData}) => {
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th>Fabric</th>
          <th>Quantity</th>
          <th>Unit</th>
          <th>Price</th>
          <th>Dis %</th>
          <th>Amount INR</th>
          <th>GST %</th>
        </tr>
      </thead>
      <tbody>
          {poChildData.map((po,index)=>(
            <tr key={index}>
              <td>{index+1}</td>
              <td className='text-start'>{po.name}</td>
              <td>{po.qty}</td>
              <td>{po.unit}</td>
              <td>{po.price}</td>
              <td>{po.discount}</td>
              <td>{po.amount}</td>
              <td>{po.gst}</td>
          </tr>
          ))}
      </tbody>
    </Table>
  )
}

export default Podetails
